module.exports = __webpack_public_path__ + "img/user.ade4d396.svg";